function isPreviewBuild() {
  const isPreview = import.meta.env.VITE_PREVIEW === "true";
  return isPreview;
}

export default isPreviewBuild;
